// 100vh fix for safari iOS
// instead of using 100vh in css calc expression, we can now use calc(var(--shell-app-height) ..)

const appHeight = () => {
  document.documentElement.style.setProperty('--shell-app-height', `${window.innerHeight}px`);
};
window.addEventListener('resize', appHeight);
appHeight();

export {};
